// The photos and PDFs an owner message carried (TOM-671, ADR 0269), in the
// owner's bubble above their words: Neo's chats and the Watch.

import { chatAttachmentSrc, type UploadedChatAttachment } from '../lib/chatAttachments';

/**
 * The photos and PDFs an owner message carried (TOM-671): a photo as a small
 * picture, a PDF as its name, each opening the file in a new tab. The bytes are
 * read with the owner's own session (§12.18).
 */
export function MessageAttachments({
  attachments,
}: {
  attachments: readonly UploadedChatAttachment[];
}) {
  return (
    <ul className="neo-message-files" aria-label="Photos and files">
      {attachments.map((a) => {
        const src = chatAttachmentSrc(a.attachmentId);
        const name = a.filename ?? (a.kind === 'image' ? 'Photo' : 'PDF');
        return (
          <li key={a.attachmentId}>
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className={`neo-message-file neo-message-file--${a.kind}`}
              title={name}
              data-testid="neo-message-file"
            >
              {a.kind === 'image' ? (
                <img
                  src={src}
                  alt={name}
                  width={a.width}
                  height={a.height}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <>
                  <FileGlyph />
                  <span className="neo-message-file__name">{name}</span>
                  {a.pages !== undefined ? (
                    <span className="neo-message-file__meta">
                      {a.pages === 1 ? '1 page' : `${a.pages} pages`}
                    </span>
                  ) : null}
                </>
              )}
            </a>
          </li>
        );
      })}
    </ul>
  );
}

// Lucide file, for a PDF in a message.
function FileGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    </svg>
  );
}
